<div class="boolean-rule" [formGroup]="parentForm">
  <p class="rule-description">
    Simple on/off toggle for the feature flag. This will globally enable or disable the feature for all users.
  </p>

  <div class="toggle-container" formGroupName="rule">
    <div class="toggle-option">
      <input type="radio" id="boolean-true" formControlName="value" [value]="true" (change)="toggleValue(true)" />
      <label for="boolean-true">Always Enabled</label>
      <span class="option-description">The feature will be enabled for all users.</span>
    </div>

    <div class="toggle-option">
      <input type="radio" id="boolean-false" formControlName="value" [value]="false" (change)="toggleValue(false)" />
      <label for="boolean-false">Always Disabled</label>
      <span class="option-description">The feature will be disabled for all users.</span>
    </div>
  </div>
</div>
